import { INGREDIENT_INITIAL_STATE } from './chunk-VSPEQRDU.mjs';
import { BASE_STORE_INITIAL_STATE } from './chunk-7PCIVIEC.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/state/menu/initialStates/items_initialState.ts
var ITEM_LINKED_MODIFIER_ITEM_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  modifierItemId: 0
});
var MODIFIER_GROUP_MODIFIER_ITEM_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  modifierItemId: 0,
  locationId: 0,
  sortPriority: 0,
  active: true,
  isSelected: false,
  defaultQuantitySelected: 0,
  defaultAmountSelected: "regular" /* REGULAR */,
  modifierItemPricingVersionId: 0,
  includedMasterPrice: 0,
  additionalMasterPrice: 0,
  applyPiecePricing: false,
  quarterPricePercent: 0,
  halfPricePercent: 0,
  customIncludedQuantityPricing: false,
  includedLightPrice: 0,
  includedRegularPrice: 0,
  includedExtraPrice: 0,
  customAdditionalQuantityPricing: false,
  additionalLightPrice: 0,
  additionalRegularPrice: 0,
  additionalExtraPrice: 0,
  name: "",
  is86ed: false,
  locationModifierGroupPricingVersionId: 0,
  locationModifierItemPricingVersionId: 0,
  locationMgpvLocationMipvVersionId: 0,
  modifierGroups: {},
  override: {},
  defaultModifierItemPricingVersionId: 0,
  maximumQuantity: 0,
  inheritedActive: true
});
var MODIFIER_GROUP_ITEMS_OVERRIDE_INITIAL_STATE = {
  active: false,
  advancedModifier: false,
  defaultModifierGroupPricingVersionId: false,
  requiredModifierItems: false,
  includedModifierItems: false,
  maximumModifierItems: false
};
var MODIFIER_GROUP_ITEMS_INITIAL_STATE = () => __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  locationModifierGroupItemsId: 0,
  modifierGroupItemsId: 0,
  modifierGroupId: 0,
  locationId: 0,
  active: true,
  sortPriority: 0,
  requiredModifierItems: 0,
  includedModifierItems: 0,
  maximumModifierItems: 0,
  defaultModifierGroupPricingVersionId: 0,
  modifierItems: {
    0: MODIFIER_GROUP_MODIFIER_ITEM_INITIAL_STATE
  },
  modifierGroupMenuTypeItemId: 0,
  posName: "",
  checkName: "",
  quantityMode: "x1,x2,x3",
  multiselect: true,
  priceCalcMode: "max",
  locationModifierGroupMenuTypeItemVersionId: 0,
  defaultSelectionPrice: 0,
  hidePriceIfFree: false,
  override: MODIFIER_GROUP_ITEMS_OVERRIDE_INITIAL_STATE,
  allowNoneSelection: false,
  global: false,
  isAllMod: false,
  isPremadeHeader: false,
  inheritedActive: true
});
var INGREDIENT_ITEMS_INITIAL_STATE = __spreadProps(__spreadValues(__spreadValues({}, BASE_STORE_INITIAL_STATE), INGREDIENT_INITIAL_STATE), {
  isSelected: true,
  sortPriority: 1
});
var MENU_TYPE_VERSION_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  locationItemId: 0,
  menuTypeId: 0,
  courseId: null,
  specialTagId: null,
  posName: "",
  kdsName: "",
  checkName: "",
  description: "",
  imageUrl: null,
  secondaryImageUrl: null,
  onlineDescription: "",
  recipe: "",
  backgroundColor: null,
  textColor: null,
  kdsColor: null,
  allowSharing: true,
  customizer: false,
  active: true,
  activeOnline: true,
  delivery: false,
  calories: null,
  prepTime: 0,
  showAllMods: false,
  ageRestricted: false,
  ageThreshold: 0,
  itemPrice: 0,
  onlinePrice: 0,
  deliveryPrice: 0,
  toGoPrice: 0,
  taxInclusive: false,
  excludeFromSuggestedTip: false,
  suggestiveOrdering: false,
  suggestiveOrderingItemId: 0,
  suggestiveOrderingItemPrice: null,
  suggestiveOrderingPrompt: "",
  onlineName: "",
  menuTypeLocationItemId: 0,
  modifierGroups: {},
  initialAmount: 0,
  currentAmount: 0,
  resetStockDaily: false,
  showOnFreshSheet: false,
  menuTypeItemId: 0,
  locationId: 0,
  locationMenuTypeItemId: 0,
  locationMenuTypeItemVersionId: 0,
  defaultModifiersPrice: 0,
  customizerShape: "",
  sortPriority: 0,
  excludeFromDiscounts: false,
  removeFromCheck: false,
  is86ed: false,
  trackInventory: false,
  actionWhenCurrentStockZero: null,
  showQuantityOnItemCard: false,
  freshSheetSortPriority: 0,
  combos: {},
  prepStationIds: [],
  specials: {},
  showPrepStationSelectionModal: true,
  defaultNoSeat: false,
  displayPictureOnCard: false,
  allModsBehavior: "all" /* ALL */,
  allModIds: [],
  ingredients: {},
  showIngredients: true,
  taxIds: [],
  inheritedTaxes: {
    menuTypeInheritedTaxes: {},
    categoryInheritedTaxes: {},
    subcategoryInheritedTaxes: {}
  },
  volume: 0,
  unit: "ml" /* ML */,
  enterItemDetails: false,
  showModifiers: true,
  showModItemPrice: true,
  exitItemDetailsOnRequiredModCompletion: false,
  spacesBefore: 0,
  categoriesSubcategories: {},
  displayItemPriceOnRegister: true,
  hideItemName: false,
  transparentBackground: false,
  doneIsForTable: false,
  universalProductCode: "",
  showAllModsAlphabetizeButtons: false,
  showAllModsHalfSizeButtons: false,
  promptForPrice: false,
  dimensionsSellBy: "unit" /* UNIT */,
  dimensionsVolumePerUnit: 0,
  dimensionsWeightPerUnit: 0,
  dimensionsVolumeUnit: "flOz" /* FL_OZ */,
  dimensionsWeightUnit: "lb" /* LB */,
  taxExempt: false
});
var ITEM_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  organizationId: 0,
  createdByLocationId: 0,
  name: "",
  locationItemId: 0,
  itemId: 0,
  customId: "",
  menuTypeVersions: {
    "0": MENU_TYPE_VERSION_INITIAL_STATE
  },
  linkedModifierItems: {},
  reportingGroupIds: []
});
var ITEM_INITIAL_STATE_FOR_SAVING = __spreadProps(__spreadValues({}, ITEM_INITIAL_STATE), {
  menuTypeVersions: {}
});
var MASS_UPDATE_INITIAL_STATE = {
  categoryId: -1,
  subcategoryId: -1,
  courseId: -1,
  specialTagId: -1,
  imageUrl: "\xABNo Changes\xBB" /* NO_CHANGES */,
  secondaryImageUrl: "\xABNo Changes\xBB" /* NO_CHANGES */,
  description: "\xABNo Changes\xBB" /* NO_CHANGES */,
  onlineDescription: "\xABNo Changes\xBB" /* NO_CHANGES */,
  recipe: "\xABNo Changes\xBB" /* NO_CHANGES */,
  backgroundColor: "\xABNo Changes\xBB" /* NO_CHANGES */,
  textColor: "\xABNo Changes\xBB" /* NO_CHANGES */,
  kdsColor: "\xABNo Changes\xBB" /* NO_CHANGES */,
  allowSharing: -1,
  active: "\xABNo Changes\xBB" /* NO_CHANGES */,
  activeOnline: "\xABNo Changes\xBB" /* NO_CHANGES */,
  delivery: "\xABNo Changes\xBB" /* NO_CHANGES */,
  defaultNoSeat: "\xABNo Changes\xBB" /* NO_CHANGES */,
  calories: "\xABNo Changes\xBB" /* NO_CHANGES */,
  prepTime: "\xABNo Changes\xBB" /* NO_CHANGES */,
  ageRestricted: "\xABNo Changes\xBB" /* NO_CHANGES */,
  ageThreshold: "\xABNo Changes\xBB" /* NO_CHANGES */,
  customizer: "\xABNo Changes\xBB" /* NO_CHANGES */,
  customizerShape: "\xABNo Changes\xBB" /* NO_CHANGES */,
  itemPrice: null,
  onlinePrice: null,
  deliveryPrice: null,
  toGoPrice: null,
  taxInclusive: "\xABNo Changes\xBB" /* NO_CHANGES */,
  taxExempt: "\xABNo Changes\xBB" /* NO_CHANGES */,
  excludeFromSuggestedTip: "\xABNo Changes\xBB" /* NO_CHANGES */,
  excludeFromDiscounts: "\xABNo Changes\xBB" /* NO_CHANGES */,
  removeFromCheck: "\xABNo Changes\xBB" /* NO_CHANGES */,
  suggestiveOrdering: "\xABNo Changes\xBB" /* NO_CHANGES */,
  suggestiveOrderingItemId: 0,
  suggestiveOrderingItemPrice: null,
  suggestiveOrderingPrompt: "",
  modifierGroups: {},
  initialAmount: "\xABNo Changes\xBB" /* NO_CHANGES */,
  currentAmount: "\xABNo Changes\xBB" /* NO_CHANGES */,
  trackInventory: "\xABNo Changes\xBB" /* NO_CHANGES */,
  resetStockDaily: "\xABNo Changes\xBB" /* NO_CHANGES */,
  showOnFreshSheet: "\xABNo Changes\xBB" /* NO_CHANGES */,
  is86ed: "\xABNo Changes\xBB" /* NO_CHANGES */,
  actionWhenCurrentStockZero: "\xABNo Changes\xBB" /* NO_CHANGES */,
  showQuantityOnItemCard: "\xABNo Changes\xBB" /* NO_CHANGES */,
  removeModifierGroups: [],
  defaultModifiersPrice: 0,
  locationIds: [],
  removeLocationIds: [],
  displayPictureOnCard: "\xABNo Changes\xBB" /* NO_CHANGES */,
  prepStationIds: [],
  removePrepStationIds: [],
  showPrepStationSelectionModal: "\xABNo Changes\xBB" /* NO_CHANGES */,
  showAllMods: "\xABNo Changes\xBB" /* NO_CHANGES */,
  allModsBehavior: -1,
  allModIds: [],
  ingredients: {},
  showIngredients: "\xABNo Changes\xBB" /* NO_CHANGES */,
  inheritedTaxes: "\xABNo Changes\xBB" /* NO_CHANGES */,
  taxIds: [],
  removeTaxIds: [],
  volume: 0,
  unit: "ml" /* ML */,
  enterItemDetails: "\xABNo Changes\xBB" /* NO_CHANGES */,
  showModifiers: "\xABNo Changes\xBB" /* NO_CHANGES */,
  showModItemPrice: "\xABNo Changes\xBB" /* NO_CHANGES */,
  exitItemDetailsOnRequiredModCompletion: "\xABNo Changes\xBB" /* NO_CHANGES */,
  displayItemPriceOnRegister: "\xABNo Changes\xBB" /* NO_CHANGES */,
  hideItemName: "\xABNo Changes\xBB" /* NO_CHANGES */,
  linkedModifierItems: {},
  transparentBackground: "\xABNo Changes\xBB" /* NO_CHANGES */,
  doneIsForTable: "\xABNo Changes\xBB" /* NO_CHANGES */,
  categoriesSubcategories: {},
  removeCategoriesSubcategories: {},
  showAllModsAlphabetizeButtons: "\xABNo Changes\xBB" /* NO_CHANGES */,
  showAllModsHalfSizeButtons: "\xABNo Changes\xBB" /* NO_CHANGES */,
  reportingGroupIds: [],
  removeReportingGroupIds: [],
  promptForPrice: "\xABNo Changes\xBB" /* NO_CHANGES */,
  dimensionsSellBy: "\xABNo Changes\xBB" /* NO_CHANGES */,
  dimensionsVolumePerUnit: "\xABNo Changes\xBB" /* NO_CHANGES */,
  dimensionsWeightPerUnit: "\xABNo Changes\xBB" /* NO_CHANGES */,
  dimensionsVolumeUnit: "\xABNo Changes\xBB" /* NO_CHANGES */,
  dimensionsWeightUnit: "\xABNo Changes\xBB" /* NO_CHANGES */
};

export { INGREDIENT_ITEMS_INITIAL_STATE, ITEM_INITIAL_STATE, ITEM_INITIAL_STATE_FOR_SAVING, ITEM_LINKED_MODIFIER_ITEM_INITIAL_STATE, MASS_UPDATE_INITIAL_STATE, MENU_TYPE_VERSION_INITIAL_STATE, MODIFIER_GROUP_ITEMS_INITIAL_STATE, MODIFIER_GROUP_ITEMS_OVERRIDE_INITIAL_STATE, MODIFIER_GROUP_MODIFIER_ITEM_INITIAL_STATE };
